import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XenaClient } from 'src/app/services';
import { IActiveTerms, ITermsData } from 'src/app/xena-api/dtos';
import { ITermsAcceptingFilter, defaultListOptionsFilter } from 'src/app/xena-api/filters';
import { Page, ISaveResult } from 'src/app/xena-api/response-types';

@Injectable({
  providedIn: 'root'
})
export class TermsHandlingService {

  constructor(private xenaClient: XenaClient) {
  }

  list(filter: ITermsAcceptingFilter = defaultListOptionsFilter): Observable<Page<IActiveTerms>> {
    const resourcePath: string = '/XenaTerms';
    return this.xenaClient.list<IActiveTerms, ITermsAcceptingFilter>(resourcePath, filter);
  }
}
